import styled from 'styled-components';

export const EmptyStateStyled = styled.div`
	margin-bottom: 40px;
	width: 100%;
	text-align: center;
`;

export const EmptyStateImageStyled = styled.img`
	margin-bottom: 24px;
`;

export const EmptyStateHeadingStyled = styled.h3`
	margin-bottom: 12px;
	font-weight: 600;
	font-size: 20px;
`;

export const EmptyStateDescriptionStyled = styled.p`
	margin: 0 auto;
	max-width: 330px;
	font-size: 14px;
`;
